import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import esCommon from './es/common.json';
import enCommon from './en/common.json';
import esAuth from './es/auth.json';
import enAuth from './en/auth.json';
import esCatalog from './es/catalog.json';
import enCatalog from './en/catalog.json';
import esCart from './es/cart.json';
import enCart from './en/cart.json';

/** v1 Colombia: UI forzada a español (recursos EN se mantienen para v2). */
const getInitialLanguage = (): string => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('i18nextLng', 'es');
  }
  return 'es';
};

i18n
  .use(initReactI18next)
  .init({
    lng: getInitialLanguage(),
    fallbackLng: 'es',
    supportedLngs: ['es', 'en'],
    interpolation: {
      escapeValue: false,
    },
    resources: {
      es: {
        common: esCommon,
        auth: esAuth,
        catalog: esCatalog,
        cart: esCart,
      },
      en: {
        common: enCommon,
        auth: enAuth,
        catalog: enCatalog,
        cart: enCart,
      },
    },
    defaultNS: 'common',
  });

export default i18n;
